import bodymovin from 'lottie-web';

export default {
  init() {

  },
  finalize() {
    const lottieIdenitifier = 'div[class^="lottie-"]';
    if ($(lottieIdenitifier).length > 0) {
      $(lottieIdenitifier).each(function() {
        if (!$(this).data('no-preload')) {
          const className = $(this).prop('class').substring(7);
          const filename = $('body').data('resources-path') + `/assets/lottie/${className}.json`;
          const $container = $(this);

          let autoplay = true;
          let loop = true;

          if ($container.data('autoplay') === false) autoplay = false;
          if ($container.data('loop') === false) loop = false;

          const animation = bodymovin.loadAnimation({
            container: $container[0],
            path: filename,
            renderer: 'svg',
            loop: loop,
            autoplay: autoplay,
          });

          if ($(this).data('speed')) {
            animation.setSpeed($(this).data('speed'));
          }

          $(this).on('lottie-pause', function() {
            animation.pause();
          });

          $(this).on('lottie-play', function() {
            animation.play();
          });
        }
      });
    }
  },
}


// WEBPACK FOOTER //
// ./scripts/partials/other/lottie.js